import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Live() {
  return (
    <div>
      <Paragraph size="2">
        This reference contains methods for both one-time live events and recurring live events.
        Whenever we talk about live events without qualifying the event type, we're referring to
        recurring live events. Methods specific to one-time live events are always expressly labeled
        as such.
      </Paragraph>

      <Paragraph size="2">
        One-time live events are being deprecated. We recommend that you avoid using the methods for
        these.
      </Paragraph>

      <Paragraph size="2">
        Please note that our live API is available only to Vimeo Enterprise customers.{' '}
        <Link variant="minimal" href="https://vimeo.com/enterprise?mkc=liveapi">
          Learn more about Vimeo Enterprise.
        </Link>{' '}
      </Paragraph>
    </div>
  );
}
